import { z } from 'zod';
/** Egysegesitett hibavalasz - minden vegpont ezt adja hiba eseten. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
export const healthSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    uptimeSeconds: z.number(),
    checks: z.record(z.string(), z.enum(['ok', 'fail'])),
});
export const ERROR_CODES = {
    unauthorized: 'unauthorized',
    forbidden: 'forbidden',
    notFound: 'not_found',
    validation: 'validation_failed',
    rateLimited: 'rate_limited',
    internal: 'internal_error',
};
/**
 * A megujitott munkamenet fejlece.
 *
 * A szerver hasznalatra megujitja a munkamenetet, hogy senkit ne leptessen ki
 * munka kozben. Bongeszoben ezt a suti intezi; az asztali appban viszont a
 * felulet tarolja a tokent, ezert a frisset ebben a fejlecben kapja meg.
 *
 * A KOZOS csomagban van, mert ket oldal olvassa ugyanazt a nevet - kulon
 * definialva egy atirasnal az egyik helyen elmaradna, es a megujitas csendben
 * hatastalan lenne.
 */
export const SESSION_REFRESH_HEADER = 'x-avslack-session';
//# sourceMappingURL=api.js.map